import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useApi from '../useApi';
import { toast } from 'react-toastify';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import FolderIcon from '@mui/icons-material/Folder';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Items from './Items';

const MasterList = () => {
    const { projectId, packageId } = useParams();
    const [itemsParams, setItemsParams] = useState(null);
    const [newGroupName, setNewGroupName] = useState('');
    const [newGroupNotes, setNewGroupNotes] = useState('');
    const [item, setItem] = useState(null);
    const [{ data: groups, loading }, callApi] = useApi();

    useEffect(() => {
        callApi({ url: `/api/projects/${projectId}/packages/${packageId}/master_list_groups` });
    }, [projectId, packageId, callApi]);

    const handleCreateGroup = async (e) => {
        e.preventDefault();
        callApi({
            url: `/api/projects/${projectId}/packages/${packageId}/master_list_groups`,
            method: 'POST',
            body: {
                group_name: newGroupName,
                notes: newGroupNotes
            }
        })
            .then(() => {
                toast.success("Group created successfully!");
                // Reset form fields
                setNewGroupName('');
                setNewGroupNotes('');
                // Re-fetch groups to update the list
                callApi({ url: `/api/projects/${projectId}/packages/${packageId}/master_list_groups` });
            });
    };

    return (
        <div className="content-container">
            <h2>Master List Groups for Package {packageId}</h2>
            {loading && <div>Loading...</div>}
            <form onSubmit={handleCreateGroup} className="form-container">
                <textarea
                    placeholder="Group Name"
                    value={newGroupName}
                    onChange={e => setNewGroupName(e.target.value)}
                    required
                    className="form-textarea"
                />
                <textarea
                    placeholder="Notes"
                    value={newGroupNotes}
                    onChange={e => setNewGroupNotes(e.target.value)}
                    className="form-textarea"
                />
                <button type="submit" className="form-button">Create New Group</button>
            </form>
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>

                {Array.isArray(groups) ? groups.map(group => (<>
                    <ListItem
                        secondaryAction={
                            <IconButton onClick={() => setItemsParams({ projectId, packageId, groupId: group.id })} edge="end" aria-label="delete">
                                <ArrowForward />
                            </IconButton>
                        }
                    >
                        <ListItemAvatar>
                            <IconButton href={`/projects/${projectId}/packages/${packageId}/master_list/${group.id}/items`}>
                                <FolderIcon />
                            </IconButton>
                        </ListItemAvatar>
                        <ListItemText
                            primary={group.group_name}
                            secondary={
                                <React.Fragment>

                                    {group.notes ? (
                                        <>
                                            <Typography
                                                sx={{ display: 'inline' }}
                                                component="span"
                                                variant="body2"
                                                color="text.primary"
                                            >
                                                Notes:
                                            </Typography>
                                            <Typography
                                                sx={{ display: 'inline' }}
                                                component="span"
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                {group.notes}
                                            </Typography>
                                        </>
                                    ) : ''}
                                </React.Fragment>
                            }
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                </>))
                    : null}
            </List>
            {itemsParams && (
                <Items {...itemsParams} form={false} />
            )}
        </div>
    );
};


export default MasterList;
